export default __webpack_public_path__ + "img/pin_icons/air_curtain_b.svg";